// extracted by mini-css-extract-plugin
export default {"container":"XM-z","topReviewHeading":"YM-z","criticalReview":"ZM-z","favorableReview":"_M-z","vsSeparator":"aN-z"};